import logoInner from '../img/ugi_logo_inner.svg';
import logoOuter from '../img/ugi_logo_outer.svg';
import fbIco from '../img/fb_ico.svg';
import telIco from '../img/tel_ico.svg';
import zaloIco from '../img/zalo_ico.svg';
import locIco from '../img/loc_ico.svg';
import webIco from '../img/web_ico.svg';
import './AboutUs.css';

function AboutUsView() {
  return (
    <div className="view">
      <header className="header">
        <div id="Ugi-logo">
          <img src={logoOuter} id="logo-outer" alt="logo outer" className="Ugi-logo"/>
          <img src={logoInner} id="logo-inner" alt="logo inner" className="Ugi-logo"/>
        </div>
        <h1>
          Trà sữa Ugi is comming soon.
        </h1>
        <nav>
          <p>Ghé thăm chúng tôi bằng các link dưới đây</p>
          <a href="https://facebook.com/trasuaugi" className="link">
            <img src={fbIco} alt="facebook ico" className="ico" />
          </a>
          <a href="tel:+84898678906" className="link">
            <img src={telIco} alt="tel ico" className="ico" /></a>
          <a href="https://zalo.me/0898678906" className="link">
            <img src={zaloIco} alt="zalo ico" className="ico" /></a>
          <a href="https://trasuaugi.business.site" className="link">
            <img src={locIco} alt="location ico" className="ico" /></a>
          <a href="https://trasuaugi.web.app" className="link">
            <img src={webIco} alt="website ico" className="ico" /></a>
        </nav>
      </header>
    </div>
  );
}

export default AboutUsView;
